import { render, staticRenderFns } from "./DiseaseDetailStyled.vue?vue&type=template&id=ab598c1c&scoped=true"
import script from "./DiseaseDetailStyled.vue?vue&type=script&lang=js"
export * from "./DiseaseDetailStyled.vue?vue&type=script&lang=js"
import style0 from "./DiseaseDetailStyled.vue?vue&type=style&index=0&id=ab598c1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab598c1c",
  null
  
)

export default component.exports